import React, { useEffect, useState } from "react";
import useWebSocket from "react-use-websocket";
import { Cookies } from "react-cookie";
import TableWithSkeleton from "../../../components/global/table/TableWithSkeleton";
import columns from "../../../columns/OpenTrades";

const OpenTrades = ({ type }) => {
  const cookies = new Cookies();
  const [socketData, setSocketData] = useState(null);

  const { sendJsonMessage, lastJsonMessage } = useWebSocket(
    `wss://backend.rimglobal.trade/api/MTFiveAccount/ws?authorization=Bearer ${cookies.get("token")}`,
    { shouldReconnect: () => true, share: true }
  );

  useEffect(() => {
    sendJsonMessage({ eventType: "Top20OpenTrades", action: "subscribe" });
    return () => {
      sendJsonMessage({ eventType: "Top20OpenTrades", action: "unsubscribe" });
    };
  }, []);

  useEffect(() => {
    setSocketData(lastJsonMessage?.data);
  }, [lastJsonMessage]);
  return (
    <div>
      <TableWithSkeleton columns={columns} data={socketData?.[type]} />
    </div>
  )
};

export default OpenTrades;
